import React from 'react';
import { Flex, Text, Box, Container, UnorderedList, ListItem, Link } from '@chakra-ui/react';


function ServiceAndMembership() {
    return (
    <>
        <Container maxW="1000px" py={5} centerContent>
            {/* Header Section */}
            <Flex direction="column" align="left">
                <Text fontSize="25px" fontWeight="bold" textAlign="center">
                    Teaching portfolio of{" "}
                    <Link href="/">
                        <Text as="span" color="blue.600" fontStyle="italic" fontWeight="bold" textDecoration="underline">
                            Dr. Burak Kantarci 
                        </Text>
                    </Link>
                </Text>
            </Flex>

            {/* 2021 Winter Section */}
            <Box mt={6} w="100%">
                <Text fontSize="lg" fontWeight="bold" textDecoration="underline">2021 Winter to Present</Text>

                <Text fontWeight="bold" color="red">
                    Click for my graduate course {" "}
                    <Text as="span" color="red" fontWeight="bold">ELG5142/CSI5140 W00</Text> {" "}
                    ➜ {" "}
                    <a href="http://site.uottawa.ca/~bkantarc/syllabi/CSI5140G-SyllabusF19.pdf" rel="noopener noreferrer" target="_blank" style={{ color: 'blue', textDecoration: 'underline', fontWeight:"normal" }}>Tentative Syllabus</a>{" "}
                    <Text as="span" color="black" fontWeight="normal">[from previous year]</Text>
                </Text> 

                

                <Text fontStyle="italic" mt={1}>Ubiquitous Sensing for Smart Cities</Text>
            </Box>

            {/* 2020 Fall Section */}
            <Box mt={6} w="100%">
                <Text fontSize="lg" fontWeight="bold" textDecoration="underline">2020 Fall</Text>

                <Text fontWeight="bold">ELG5255 Applied Machine Learning{" "}
                    <Text as="span" fontSize="sm">
                        *This course requires special interaction with student teams throughout the term. 
                        Audit mode participation is <Text as="span" fontWeight="bold" textDecoration="underline">not</Text> possible.
                    </Text>
                </Text>

                <a href="https://www.site.uottawa.ca/~bkantarc/ELG5255-SyllabusF20-.pdf" rel="noopener noreferrer" target="_blank" style={{ color: 'blue', textDecoration: 'underline' }}>Tentative Syllabus</a>{" "}
                    
            </Box>

            <Box mt={6} w="100%">
                <Text fontSize="lg" fontWeight="bold" textDecoration="underline">
                    Courses taught at University of Ottawa (since 2016)
                </Text>

                <UnorderedList mt={3} pl={5}>
                    <ListItem>CSI5140/ELG5142 Ubiquitous Sensing for Smart Cities</ListItem>
                    <ListItem>CSI5140 Information & Communication Systems for Smart Cities (under Selected Topics in Computer Science)</ListItem>
                    <ListItem>SEG4135 Cloud Systems and Networks</ListItem>
                    <ListItem>CSI 3131 Operating Systems</ListItem>
                    <ListItem>SEG4300 Topics in Software Engineering</ListItem>
                    <ListItem>CEG2136 Computer Architecture I</ListItem>
                </UnorderedList>
            </Box>

            <Box mt={6} w="100%">
                <Text fontSize="lg" fontWeight="bold" textDecoration="underline">
                  Courses taught at Clarkson University (past teaching experience 2014-2016)
                </Text>

                <UnorderedList mt={3} pl={5}>
                    <ListItem>EE512/CS667 Cloud Systems and Networks</ListItem>
                    <ListItem>EE491 / EE 693 Directed Study in Electrical and Computer Engineering (Independent Study)</ListItem>
                    <ListItem>EE 408 Software Design for Visual Environments:</ListItem>
                </UnorderedList>
            </Box>



            <Box mt={6} w="100%">
                <Text fontSize="lg" fontWeight="bold" textDecoration="underline">
                  Past teaching experience at ITU (before 2010)
                </Text>


                <Text fontSize="l" fontWeight="bold" padding="10px">
                Computer Engineering
                </Text>
                <UnorderedList mt={1} pl={5}>
                    <ListItem>Introduction to Scientific and Engineering Computing (C/C++)</ListItem>
                    <ListItem>Digital Signal Processing Lab</ListItem>
                </UnorderedList>

                <Text fontSize="l" fontWeight="bold" padding="10px">
                Information Technologies
                </Text>
                <UnorderedList mt={1} pl={5}>
                    <ListItem>Computer and Network Security</ListItem>
                    <ListItem>Computer Operating Systems (Advanced)</ListItem>
                    <ListItem>Structured Programming (Java)</ListItem>
                    <ListItem>Data Structures</ListItem>
                </UnorderedList>


            </Box>


        </Container>
        
      
    </>
    );
  }


  export default ServiceAndMembership;